import React from 'preact/compat';
import { JSX } from 'preact';
import { useFileUrl } from './hooks';

export default function FilePreview({ file, alt = '', children, ...rest }: FilePreviewProps) {
    const url = useFileUrl(file);

    if (url === null) {
        return null;
    }

    return <img src={url} alt={alt} {...rest} />;
}

type FilePreviewProps = JSX.HTMLAttributes<HTMLImageElement> & {
    file: File,
};
